/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Cta_CompareInputs */

const en_vc_cta_compare = /** @type {(inputs: Vc_Cta_CompareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VectorCraft vs Illustrator`)
};

const zh_vc_cta_compare = /** @type {(inputs: Vc_Cta_CompareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VectorCraft 与 Illustrator 对比`)
};

/**
* | output |
* | --- |
* | "VectorCraft vs Illustrator" |
*
* @param {Vc_Cta_CompareInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_cta_compare = /** @type {((inputs?: Vc_Cta_CompareInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Cta_CompareInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_cta_compare(inputs)
	return zh_vc_cta_compare(inputs)
});
export { vc_cta_compare as "vc.cta.compare" }